const timeHhMm = function (date: Date): string {
  const dateObject = new Date(date);
  const [hours, minutes] = [dateObject.getHours(), dateObject.getMinutes()];

  return `${hours == 0 ? "00" : hours}:${minutes == 0 ? "00" : minutes}`;
};

export default timeHhMm;
